import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../../colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    backgroundColor: 'white',
  },
  welcomeBox: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral100}`,
    background: colors.white,
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    alignSelf: 'stretch',
  },
  welcomeFrame: {
    display: 'flex',
    padding: '32px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '32px',
    alignSelf: 'stretch',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  sectionTitle: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
    margin: 0,
  },
  sectionSubtitle: {
    color: colors.neutral500,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    margin: 0,
  },
  askBox: {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
    backgroundColor: colors.neutral25,
  },
  contentHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px'
  },
  sayBox: {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: colors.primary50,
  },
  askContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '40px',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch'
  },
  firstLineLayout: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  firstLine: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    flex: 1,
    margin: 0,
  },
  askIcon: {
    color: colors.secondary500,
    height: '24px',
    width: '24px',
    '& path': {
      fill: colors.secondary500,
    },
  },
  sayIcon: {
    color: colors.primary,
    height: '24px',
    width: '24px',
    // '& path': {
    //   fill: colors.primary,
    // },
  },
  instruction: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
    padding: '12px',
    borderRadius: '2px 12px 12px 12px',
  },
  danger: {
    color: colors.destructive500,
  },
  planBox: {
    display: 'flex',
    width: '100%',
    padding: '0px 40px',
    flexDirection: 'column',
    background: colors.white,
  },
  planBoxHeader: {
    display: 'flex',
    padding: '24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: '24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  planBoxTitle: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    margin: 0,
  },
  planBoxSubtitle: {
    color: colors.neutral600,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
  },
  planContent: {
    display: 'flex',
    flexDirection: 'column',
    // gap: '32px',
  },
  problemBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '&:not(:last-child)': {
      borderBottom: `1px solid ${colors.neutral100}`,
    },
  },
  modalitiesBox: {
    padding: '24px',
    paddingBottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
  problemHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  problemTitle: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },
  problemDetail: {
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
  },
  goalBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    padding: '24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  goalHeader: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    margin: 0,
  },
  goalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
  goalDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  goalName: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
  },
  goalDescription: {
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
  objectivesBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    borderRadius: '8px',
    background: colors.primary50,
    width: '45%',
  },
  objectivesHeader: {
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
  objectivesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  objectiveItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
  starIcon: {
    width: '24px',
    height: '24px',
    color: colors.secondary500,
  },
  checkIcon: {
    width: '16px',
    height: '16px',
    color: colors.primary500,
    '& path': {
      fill: colors.primary500,
    },
  },
  idBoxContent: {
    padding: '24px',
    display: 'flex',
    gap: '16px',
  },
  cardImage: {
    width: '180px',
    height: '113px',
    borderRadius: '8px',
  },
  missingBox: {
    display: 'flex',
    padding: '36px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: colors.primary50,
  },
  missingBtn: {
    height: '40px',
    border: `1px solid ${colors.destructive300}`,
    color: colors.destructive500,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    padding: '8px 16px',
  },
  badge: {
    color: colors.neutral600,
    border: `1px solid ${colors.neutral300}`,
  },
  animatedIcon: {
    width: '80px',
    height: '80px',
  },
  objective: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  objectivesCheckIcon: {
    width: 16,
    height: 16,
    minWidth: 16,
    '& path': {
      fill: colors.primary500,
    },
  },
  objectiveTile: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  visitFrequency: {
    width: 24,
    height: 24,
  },
  objectivesListItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral700,
  },
});
